module.exports = __webpack_public_path__ + "static/media/gryphon_musee_ids_retrobound_2.2df144a8.jpg";